module.exports = __webpack_public_path__ + "static/img/info_2.a0319ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_2.png
// module id = Zmud
// module chunks = 1